export const DEMO_INVOICE_CREATED_EVENT_OFFSET = 1000
